/**
 * What the gateway accepts of a conversation in one request
 * (apps/api-gateway/src/validation/generateSchemas.ts). A request over either
 * is refused whole, with a 400.
 */
export const REQUEST_HISTORY_MAX_MESSAGES = 200;
export const REQUEST_HISTORY_MAX_CHARS = 200_000;

/**
 * The conversation as a request carries it: its newest messages, as many as
 * the gateway accepts.
 *
 * The page sent every message of the conversation with every request. Past 200
 * messages, or 200 000 characters of them (a dozen delivered programs with
 * their explanations), the request was refused, and so was every one after it:
 * the conversation could not be continued or retried. The gateway does not
 * work from this copy in any case. It reads the conversation from its own
 * store, and uses what the page sends only when that store could not be
 * written; the newest messages are what such a turn needs.
 */
export function historyForRequest<T extends { content?: unknown }>(history: readonly T[] | undefined): T[] {
  const kept: T[] = [];
  let chars = 0;
  for (let index = (history?.length ?? 0) - 1; index >= 0 && kept.length < REQUEST_HISTORY_MAX_MESSAGES; index -= 1) {
    const message = history![index]!;
    const length = typeof message.content === 'string' ? message.content.length : 0;
    if (chars + length > REQUEST_HISTORY_MAX_CHARS) break;
    chars += length;
    kept.unshift(message);
  }
  return kept;
}
